import React, { FC, useCallback, useEffect, useState } from 'react'

import { StageProps } from 'sdk/react/Pipeline/Stage'
import { ACHDetails, CreditCardDetails } from 'sdk/types'

import ACH from '~p/stages/PaymentDetails/pages/ACH'
import CreditCard from '~p/stages/PaymentDetails/pages/CreditCard'
import MethodSelection from '~p/stages/PaymentDetails/pages/MethodSelection'
import Stripe from '~p/stages/PaymentDetails/pages/Stripe'
import LoadingDots from 'components/molecules/LoadingDots'

type Props = StageProps<'payment-details'>

type Step = 'select-method' | 'credit-card' | 'ach' | 'confirm'

type State = {
  step: Step
  creditCard?: CreditCardDetails
  ach?: ACHDetails
}

const PaymentDetails: FC<Props> = ({ stage, timer, error, onInitiate, onSubmit }) => {
  const [state, setState] = useState<State>({
    step: stage.configuration?.paymentDetailsType || 'select-method',
  })

  // FIXME: temp config for payment details stage
  const [config, setConfig] = useState<{
    gateway: string
    stripe: { publishableKey: string; secretKey: string }
  }>()

  const handleOnCancel = useCallback(() => {
    if (stage.configuration?.paymentDetailsType) {
      return
    }
    setState({ step: 'select-method' })
  }, [])

  useEffect(() => {
    onInitiate({}).then(res => {
      setConfig(res)
    })
  }, [onInitiate])

  if (!config) return <LoadingDots className="mt-16" />

  if (config.gateway === 'stripe') {
    return <Stripe stage={stage} config={config.stripe} onSubmit={onSubmit} error={error} />
  }

  switch (state.step) {
    case 'select-method':
      return <MethodSelection onSelect={method => setState({ step: method })} />
    case 'credit-card':
      return (
        <CreditCard
          timer={timer}
          error={error}
          onComplete={onSubmit}
          onCancel={() => handleOnCancel()}
        />
      )
    case 'ach':
      return (
        <ACH timer={timer} error={error} onComplete={onSubmit} onCancel={() => handleOnCancel()} />
      )
    default:
      return null
  }
}

export default PaymentDetails
